
<form [formGroup]="group">
    <bt-textbox-form
        [formControlName]="model.id"
        [model]="model"
        [value]="model.value"
        [required]="model.required"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)">
    </bt-textbox-form>
</form>